module.exports = __webpack_public_path__ + "tenant-promote.b0e0d7eff189abe0e19428e8235a187c.hashedasset.svg";